<script setup lang="ts">
import { type Locale, isValidLocale } from "~ui/utils/locales"
import type { Locale as I18nLocale } from "vue-i18n"
import type { DropdownMenuContentProps } from "reka-ui"

defineProps<{
  locales?: Locale[]
  popoverSide?: DropdownMenuContentProps["side"]
}>()

const { locale, setLocale } = useI18n()
const { explicitLocale } = useSavedLocale()

const emit = defineEmits<{
  openLocale: []
  selectLocale: [id: string]
}>()

function _setLocale(locale: Locale | undefined) {
  if (!locale) return

  setLocale(locale as I18nLocale)
  explicitLocale.value = locale
  emit("selectLocale", locale)
}
</script>

<template>
  <LanguageSelect
    class="w-full"
    :model-value="isValidLocale(locale) ? locale : undefined"
    :locales
    :popover-side
    @update:model-value="_setLocale"
    @open="$emit('openLocale')"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </LanguageSelect>
</template>
